<template>
  <div class="page">
    <van-nav-bar title="补卡申请" left-arrow @click-left="$router.go(-1)" fixed :placeholder="true" :safe-area-inset-top="true" />
    <van-form @submit="onSubmit">
      <van-field style="margin-top: 10px" readonly v-model="form.bksj" is-link @click="showPicker = true" rows="1" autosize label="补卡时间" input-align="right" error-message-align="right" type="textarea" placeholder="请输入" :rules="[{ required: true, message: '请选择补卡时间' }]" />
      <van-field class="textarea" style="margin-top: 10px" v-model="form.bkly" show-word-limit maxlength="200" rows="5" autosize label="补卡理由" input-align="right" type="textarea" placeholder="请输入" :rules="[{ required: true, message: '请输入补卡理由' }]" />
      <van-field name="uploader" label="图片">
        <template #input>
          <van-uploader accept="image/*" :max-size="5 * 1024 * 1024" @oversize="$toast('文件大小不能超过 5M ')" :max-count="1" :after-read="upload" v-model="fileList" />
        </template>
      </van-field>
      <div class="button-box-submit">
        <van-button round block type="info" native-type="submit">提交</van-button>
      </div>
    </van-form>
    <!-- 选择去向 -->
    <van-popup v-model="showPicker" position="bottom">
      <van-picker show-toolbar :columns="dateList" @cancel="showPicker = false" @confirm="onConfirm" />
    </van-popup>
    <!-- 选择审批人 -->
    <van-popup v-model="showPicker2" round position="bottom">
      <div class="apply-pop">
        <div class="pop-title">
          <i class="close-icon" @click="showPicker2 = false"></i>
          <p>审核人</p>
          <i class="confirm-icon" @click="saveData()"></i>
        </div>
        <div class="person">
          <button class="per-btn" ref="person" @click="personTap($event, index)" v-for="(item, index) in userList" :key="item.userid">
            {{ item.userrealname }}
          </button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import  iApi  from '@/utils/internship'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      isEdit: false,
      showPicker: false,
      fileList: [],
      where: '',
      whereList: [],
      dateList: [],
      showPicker2: false,
      userList: [
        {
          useraccount: '',
          useremail: '',
          userid: '',
          userrealname: '全部',
          isBtn: 0,
        },
      ],

      form: {
        bksj: '',
        bkly: '',
        bkzp: '',
        xnxq01id: '',
        userid: '',
        dklx:''
      },
    }
  },
  computed: {
    ...mapGetters({
      sxjhid: 'getSxjhid',
      isty: 'getIsty',
    }),
  },
  methods: {
    upload(e) {
      this.form.bkzp = e.file
    },
    onConfirm(e) {
      this.showPicker = false
      this.form.bksj = e.value
    },
    personTap(e, res) {
      console.log(e, res)
      let strList = []
      let idList = []
      if (this.userList[res].isBtn == 0) {
        this.userList[res].isBtn = 1
        e.target.className = 'cur'
      } else if (this.userList[res].isBtn == 1) {
        this.userList[res].isBtn = 0
        e.target.className = 'per-btn'
      }
      for (let i in this.userList) {
        // if (this.userList[res].userrealname == '全部') {
        //   this.userList[i].isBtn = 0
        //   this.userList[res].isBtn = 1
        //   this.$refs.person[res].className = 'cur'
        //   this.$refs.person[i].className = 'per-btn'
        // } else {
        //   this.userList[0].isBtn = 0
        //   this.$refs.person[0].className = 'per-btn'
        // }
        if (this.userList[i].isBtn == 1) {
          strList = strList.concat(this.userList[i].userrealname)
          idList = idList.concat(this.userList[i].userid)
        }
      }
      this.form.userid = idList.toString()
    },
    async onSubmit() {
      // 弹出审批人弹窗
      const res = await iApi.getReviewer({ ywcode: 672 })
      this.showPicker2 = true
      this.userList = res.data;
      this.userList.forEach((item, index) => {
        this.userList[index].isBtn = 0
      })
    },
    async saveData() {
      this.showPicker2 = false
      if(this.form.userid == null || this.form.userid == ''){
        this.$toast.fail("请选择审核人!");
        return null;
      }
      this.form.sxjhid = this.sxjhid
      const res = await iApi.setReSignInfo(this.form)
      if(res.code == '1'){
        this.$toast('申请成功')
        setTimeout(()=>{
          this.$router.go(-1)
        }, 800)
      }
    },
  },
  async created() {
    if (this.$route.query) {
      console.log(this.$route.query)
      const res = await iApi.getSignTimeList({ sxjhid: this.sxjhid, date: this.$route.query.date,bkd:this.$route.query.bkd })
      res.data.forEach(item => {
        this.dateList.push({
          text: `${this.$route.query.date} ${item}`,
          value: `${this.$route.query.date} ${item}`
        })
      })
      this.form.bksj = this.dateList[0].value
      this.form.dklx = this.$route.query.dklx 
    }
  },
}
</script>

<style lang="less" scoped>
.img-icon {
  height: 20px;
}
.van-tabs__line {
  background-color: #0088f8 !important;
  width: 25px;
}
.van-tab--active {
  color: #333333 !important;
  font-weight: 600 !important;
}
.page {
  min-height: 100vh;
  background: #f2f2f4;
  margin-top: -50px;
  .bblock {
    height: 40px;
    background: #f2f2f4;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    letter-spacing: 0;
    // padding-left: 15px;
    line-height: 50px;
    margin-left: 15px;
  }
}
.van-field__label {
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 16px !important;
  span {
    color: #333333 !important;
  }
}
.van-icon {
  color: rgb(223, 224, 240) !important;
}
.button-box-submit {
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  height: 70px;
  background: #ffffff;
  display: flex;
  justify-content: space-around;
  align-items: center;
  border: none !important;
  // border-color: #ffffff;
}
.van-button {
  width: 345px;
  height: 50px;
  border: 1px solid #e5e5e5;
  border-radius: 25px !important;
}
.apply-pop {
  width: 100%;
  position: fixed;
  bottom: 0;
  background-color: @attendance-color-3;
  box-sizing: border-box;
  border-radius: 5px 5px 0 0;
  max-height: 40%;
  overflow-y: scroll;
}
.close-icon {
  background: url(../../../../../static/img/close.png) no-repeat center;
}
.pop-title {
  display: flex;
  justify-content: space-between;
  padding: 13px;
  position: fixed;
  width: 100%;
  background-color: @attendance-color-3;
  box-sizing: border-box;
  border-radius: 5px 5px 0 0;
  z-index: 9;
}
.pop-title i {
  width: 22px;
  height: 22px;
  background-size: 22px 22px;
}
.confirm-icon {
  background: url(../../../../../static/img/confirm.png) no-repeat center;
}
.person {
  padding: 20px 20px 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: 48px;
}
.person button {
  border-radius: 3px;
  padding: 5px 15px;
  margin-right: 12px;
  margin-bottom: 15px;
}
.apply-pop .person .per-btn {
  background-color: @attendance-background-color-7;
  color: @attendance-background-color-1;
}
.person .cur {
  background-color: @attendance-background-color-1;
  color: @attendance-background-color-7;
}
.textarea{
  display: flex;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/internship/replacement.vue